












import {Component, PropSync, Vue} from 'vue-property-decorator';
import {PopupRequestData} from '@/types';

@Component
export default class TermsTemplateNotice extends Vue {
  @PropSync('isShowNotice') private isShowNoticeSync!: boolean;

  private changeVisible() {
    this.isShowNoticeSync = false;
  }
  private noticeTextList = [
    'MANAGE_SMS_AUTO_TERMS_NOTICE_TEXT_1',
    'MANAGE_SMS_AUTO_TERMS_NOTICE_TEXT_2',
    'MANAGE_SMS_AUTO_TERMS_NOTICE_TEXT_3',
  ]
  private termsTemplateNoticeData: PopupRequestData = {
    id: 'terms-template',
    width: 700,
    maxHeight: 900,
    classStr: 'lp_large',
    title: 'MANAGE_SMS_AUTO_TERMS_NOTICE_TITLE',
    hasConfirmBtn: false,
    hasCloseBtn: false,
    hasVerticalScroll: true
  };
}
